import { HttpInterceptorFn } from '@angular/common/http';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  let currentuser: any = localStorage.getItem('currentUser');
  let userdata = JSON.parse(currentuser);
  if (userdata) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${userdata.token}`
      }
    });
  }
  return next(req);
};
